module.exports = __webpack_public_path__ + "842f1ae8ed483259dc48abbcd9ccacb2.jpg";